const load = (name, path) => () => import(/* webpackChunkName: "name-[request]" */ `@/${path}`);

import auth from '../middlewares/auth';
import fallback from '../middlewares/fallback';
import guest from '../middlewares/guest';

export default [
  {
    path: '/login',
    name: 'login',
    components: {
      default: load('login', `views/Login`),
    },
    meta: {
      title: 'Bejelentkezés',
      middleware: guest,
    }
  },
  {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: load('resetPassword', `views/ResetPassword`),
    meta: {
      title: 'Új jelszó',
      middleware: guest,
    }
  },
  {
    path: '/',
    name: 'dashboard',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('dashboard', `views/Dashboard`),
    },
    meta: {
      title: 'Főoldal',
      middleware: auth,
    },
  },
  {
    path: '/users',
    name: 'users',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('users', `views/users/Users`),
    },
    meta: {
      title: 'Felhasználók',
      middleware: [auth, fallback],
      permission: 'user.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('users', 'components/users/View'),
        name: 'ViewUserDialog',
        meta: {
          title: 'Felhasználó megtekintése',
          middleware: [auth, fallback],
          showViewUserDialog: true,
          permission: 'user.view',
          fallback: 'dashboard'
        }
      },
      {
        path: 'add',
        component: load('users', 'components/users/Dialog'),
        name: 'AddUserDialog',
        meta: {
          title: 'Felhasználó hozzáadása',
          middleware: [auth, fallback],
          showAddUserDialog: true,
          permission: 'user.create',
          fallback: 'users'
        }
      },
      {
        path: 'update/:id',
        component: load('users', 'components/users/Dialog'),
        name: 'UpdateUserDialog',
        meta: {
          title: 'Felhasználó módosítása',
          middleware: [auth, fallback],
          showUpdateUserDialog: true,
          permission: 'user.create',
          fallback: 'users'
        }
      },
    ],
  },
  {
    path: '/my-profile',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('users', `views/MyProfile`),
    },
    name: 'myProfile',
    meta: {
      title: 'Saját profil',
      middleware: [auth, fallback],
    },
    children: [
      {
        path: 'update-password',
        component: load('myProfile', 'components/myProfile/PasswordDialog'),
        name: 'UpdatePasswordDialog',
        meta: {
          title: 'Jelszó módosítása',
          middleware: [auth, fallback],
          showUpdatePasswordDialog: true,
        }
      },
    ]
  },
  {
    path: '/users/categories',
    name: 'user-categories',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('user-categories', `views/users/Categories`),
    },
    meta: {
      title: 'Felhasználói csoportok',
      middleware: [auth, fallback],
      permission: 'usercategory.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('user-categories', 'components/users/categories/Dialog'),
        name: 'AddUserCategoryDialog',
        meta: {
          title: 'Felhasználói csoport hozzáadása',
          middleware: [auth, fallback],
          showAddUserCategoryDialog: true,
          permission: 'usercategory.create',
          fallback: 'user-categories'
        }
      },
      {
        path: 'update/:id',
        component: load('user-categories', 'components/users/categories/Dialog'),
        name: 'UpdateUserCategoryDialog',
        meta: {
          title: 'Felhasználói csoport módosítása',
          middleware: [auth, fallback],
          showUpdateUserCategoryDialog: true,
          permission: 'usercategory.update',
          fallback: 'user-categories'
        }
      },
    ],
  },
  {
    path: '/roles',
    name: 'roles',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('roles', `views/users/Roles`),
    },
    meta: {
      title: 'Jogkörök',
      middleware: [auth, fallback],
      permission: 'role.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('roles', 'components/roles/View'),
        name: 'ViewRoleDialog',
        meta: {
          title: 'Jogkör megtekintése',
          middleware: [auth, fallback],
          showViewRoleDialog: true,
          permission: 'role.view',
          fallback: 'dashboard'
        }
      },
      {
        path: 'add',
        component: load('roles', 'components/roles/Dialog'),
        name: 'AddRoleDialog',
        meta: {
          title: 'Jogkör hozzáadása',
          middleware: [auth, fallback],
          showAddRoleDialog: true,
          permission: 'role.create',
          fallback: 'roles'
        }
      },
      {
        path: 'update/:id',
        component: load('roles', 'components/roles/Dialog'),
        name: 'UpdateRoleDialog',
        meta: {
          title: 'Jogkör módosítása',
          middleware: [auth, fallback],
          showUpdateRoleDialog: true,
          permission: 'role.update',
          fallback: 'roles'
        }
      },
    ],
  },
  {
    path: '/lists',
    name: 'lists',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('lists', `views/Lists`),
    },
    meta: {
      title: 'Listák',
      middleware: [auth, fallback],
      permission: 'settings.country.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'vats/add',
        name: 'AddVatDialog',
        component: load('lists', 'components/lists/vat/Dialog'),
        meta: {
          title: 'Áfa hozzáadása',
          middleware: [auth, fallback],
          showAddVatDialog: true,
          permission: 'settings.vat.create',
          fallback: 'lists'
        }
      },
      {
        path: 'vats/update/:id',
        component: load('lists', 'components/lists/vat/Dialog'),
        name: 'UpdateVatDialog',
        meta: {
          title: 'Áfa módosítása',
          middleware: [auth, fallback],
          showUpdateVatDialog: true,
          permission: 'settings.vat.update',
          fallback: 'lists'
        }
      },
      {
        path: 'price-types/add',
        name: 'AddPriceTypeDialog',
        component: load('lists', 'components/lists/priceType/Dialog'),
        meta: {
          title: 'Ár típus hozzáadása',
          middleware: [auth, fallback],
          showAddPriceTypeDialog: true,
          permission: 'pricetype.create',
          fallback: 'lists'
        }
      },
      {
        path: 'price-types/update/:id',
        component: load('lists', 'components/lists/priceType/Dialog'),
        name: 'UpdatePriceTypeDialog',
        meta: {
          title: 'Ár típus módosítása',
          middleware: [auth, fallback],
          showUpdatePriceTypeDialog: true,
          permission: 'pricetype.update',
          fallback: 'lists'
        }
      },
      {
        path: 'countries/add',
        name: 'AddCountryDialog',
        component: load('lists', 'components/lists/country/Dialog'),
        meta: {
          title: 'Ország hozzáadása',
          middleware: [auth, fallback],
          showAddCountryDialog: true,
          permission: 'settings.country.create',
          fallback: 'lists'
        }
      },
      {
        path: 'countries/update/:id',
        component: load('lists', 'components/lists/country/Dialog'),
        name: 'UpdateCountryDialog',
        meta: {
          title: 'Ország módosítása',
          middleware: [auth, fallback],
          showUpdateCountryDialog: true,
          permission: 'settings.country.update',
          fallback: 'lists'
        }
      },
      {
        path: 'counties/add',
        name: 'AddCountyDialog',
        component: load('lists', 'components/lists/county/Dialog'),
        meta: {
          title: 'Megye hozzáadása',
          middleware: [auth, fallback],
          showAddCountyDialog: true,
          permission: 'settings.county.create',
          fallback: 'lists'
        }
      },
      {
        path: 'counties/update/:id',
        component: load('lists', 'components/lists/county/Dialog'),
        name: 'UpdateCountyDialog',
        meta: {
          title: 'Megye módosítása',
          middleware: [auth, fallback],
          showUpdateCountyDialog: true,
          permission: 'settings.county.update',
          fallback: 'lists'
        }
      },
      {
        path: 'gla-numbers/add',
        name: 'AddGlaNumberDialog',
        component: load('lists', 'components/lists/glaNumber/Dialog'),
        meta: {
          title: 'Főkönyvi szám hozzáadása',
          middleware: [auth, fallback],
          showAddGlaNumberDialog: true,
          permission: 'settings.glanumber.create',
          fallback: 'lists'
        }
      },
      {
        path: 'gla-numbers/update/:id',
        component: load('lists', 'components/lists/glaNumber/Dialog'),
        name: 'UpdateGlaNumberDialog',
        meta: {
          title: 'Főkönyvi szám módosítása',
          middleware: [auth, fallback],
          showUpdateGlaNumberDialog: true,
          permission: 'settings.glanumber.update',
          fallback: 'lists'
        }
      },
      {
        path: 'currencies/add',
        name: 'AddCurrencyDialog',
        component: load('lists', 'components/lists/currency/Dialog'),
        meta: {
          title: 'Valuta hozzáadása',
          middleware: [auth, fallback],
          showAddCurrencyDialog: true,
          permission: 'settings.currency.create',
          fallback: 'lists'
        }
      },
      {
        path: 'currencies/update/:id',
        component: load('lists', 'components/lists/currency/Dialog'),
        name: 'UpdateCurrencyDialog',
        meta: {
          title: 'Valuta módosítása',
          middleware: [auth, fallback],
          showUpdateCurrencyDialog: true,
          permission: 'settings.currency.update',
          fallback: 'lists'
        }
      },
      {
        path: 'customs-tariff-numbers/add',
        name: 'AddCustomsTariffNumberDialog',
        component: load('lists', 'components/lists/customsTariffNumber/Dialog'),
        meta: {
          title: 'Vámtarifaszám hozzáadása',
          middleware: [auth, fallback],
          showAddCustomsTariffNumberDialog: true,
          permission: 'settings.customstariffnumber.create',
          fallback: 'lists'
        }
      },
      {
        path: 'customs-tariff-numbers/update/:id',
        component: load('lists', 'components/lists/customsTariffNumber/Dialog'),
        name: 'UpdateCustomsTariffNumberDialog',
        meta: {
          title: 'Vámtarifaszám módosítása',
          middleware: [auth, fallback],
          showUpdateCustomsTariffNumberDialog: true,
          permission: 'settings.customstariffnumber.update',
          fallback: 'lists'
        }
      },
      {
        path: 'pack-types/add',
        name: 'AddPackTypeDialog',
        component: load('lists', 'components/lists/packType/Dialog'),
        meta: {
          title: 'Kiszereléstípus hozzáadása',
          middleware: [auth, fallback],
          showAddPackTypeDialog: true,
          permission: 'settings.packtype.create',
          fallback: 'lists'
        }
      },
      {
        path: 'pack-types/update/:id',
        name: 'UpdatePackTypeDialog',
        component: load('lists', 'components/lists/packType/Dialog'),
        meta: {
          title: 'Kiszereléstípus módosítása',
          middleware: [auth, fallback],
          showUpdatePackTypeDialog: true,
          permission: 'settings.packtype.update',
          fallback: 'lists'
        }
      },
      {
        path: 'locations/add',
        name: 'AddLocationDialog',
        component: load('lists', 'components/lists/location/Dialog'),
        meta: {
          title: 'Terület hozzáadása',
          middleware: [auth, fallback],
          showAddLocationDialog: true,
          permission: 'settings.location.create',
          fallback: 'lists'
        }
      },
      {
        path: 'locations/update/:id',
        name: 'UpdateLocationDialog',
        component: load('lists', 'components/lists/location/Dialog'),
        meta: {
          title: 'Terület módosítása',
          middleware: [auth, fallback],
          showUpdateLocationDialog: true,
          permission: 'settings.location.update',
          fallback: 'lists'
        }
      },
      {
        path: 'declutter-measures/add',
        name: 'AddDeclutterMeasureDialog',
        component: load('lists', 'components/lists/declutterMeasures/Dialog'),
        meta: {
          title: 'Selejtezési intézkedés hozzáadása',
          middleware: [auth, fallback],
          showAddDeclutterMeasureDialog: true,
          permission: 'settings.declutterMeasure.create',
          fallback: 'lists'
        }
      },
      {
        path: 'declutter-measures/update/:id',
        component: load('lists', 'components/lists/declutterMeasures/Dialog'),
        name: 'UpdateDeclutterMeasureDialog',
        meta: {
          title: 'Selejtezési intézkedés módosítása',
          middleware: [auth, fallback],
          showUpdateDeclutterMeasureDialog: true,
          permission: 'settings.declutterMeasure.update',
          fallback: 'lists'
        }
      },
    ]
  },
  {
    path: '/data/cars',
    name: 'cars',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('cars', `views/data/Cars`),
    },
    meta: {
      title: 'Gépkocsik',
      middleware: [auth, fallback],
      permission: 'administration.car.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('cars', 'components/data/cars/Dialog'),
        name: 'AddCarDialog',
        meta: {
          title: 'Gépkocsi hozzáadása',
          middleware: [auth, fallback],
          showAddCarDialog: true,
          permission: 'administration.car.create',
          fallback: 'cars'
        }
      },
      {
        path: 'update/:id',
        component: load('cars', 'components/data/cars/Dialog'),
        name: 'UpdateCarDialog',
        meta: {
          title: 'Gépkocsi módosítása',
          middleware: [auth, fallback],
          showUpdateCarDialog: true,
          permission: 'administration.car.update',
          fallback: 'cars'
        }
      },
    ],
  },
  {
    path: '/data/customer-price-lists',
    name: 'customerPriceLists',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('cars', `views/data/CustomerPriceList`),
    },
    meta: {
      title: 'Központi Árlisták',
      middleware: [auth, fallback],
      permission: 'customerpricelist.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add/:id?',
        component: load('customerPriceLists', 'components/data/customerPriceLists/Dialog'),
        name: 'AddCustomerPriceListDialog',
        meta: {
          title: 'Központi árlista hozzáadása',
          middleware: [auth, fallback],
          showAddCustomerPriceListDialog: true,
          permission: 'customerpricelist.create',
          fallback: 'customerPriceLists'
        }
      },
      {
        path: 'update/:id',
        component: load('customerPriceLists', 'components/data/customerPriceLists/Dialog'),
        name: 'UpdateCustomerPriceListDialog',
        meta: {
          title: 'Központi árlista módosítása',
          middleware: [auth, fallback],
          showUpdateCustomerPriceListDialog: true,
          permission: 'customerpricelist.update',
          fallback: 'customerPriceLists'
        }
      },
      {
        path: 'product-prices',
        component: load('customerPriceLists', 'components/data/customerPriceLists/productPrices/Dialog'),
        name: 'ProductPricesDialog',
        meta: {
          title: 'Alapértelmezett árak',
          middleware: [auth, fallback],
          showProductPricesDialog: true,
          permission: 'customerpricelist.update',
          fallback: 'customerPriceLists'
        }
      },
    ],
  },
  {
    path: '/data/categories',
    name: 'categories',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('categories', `views/data/products/Categories`),
    },
    meta: {
      title: 'Termékkategóriák',
      middleware: [auth, fallback],
      permission: 'data.productcategory.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('categories', 'components/data/products/categories/Dialog'),
        name: 'AddCategoryDialog',
        meta: {
          title: 'Termékkategória hozzáadása',
          middleware: [auth, fallback],
          showAddCategoryDialog: true,
          permission: 'data.productcategory.create',
          fallback: 'categories'
        }
      },
      {
        path: 'update/:id',
        component: load('categories', 'components/data/products/categories/Dialog'),
        name: 'UpdateCategoryDialog',
        meta: {
          title: 'Termékkategória módosítása',
          middleware: [auth, fallback],
          showUpdateCategoryDialog: true,
          permission: 'data.productcategory.update',
          fallback: 'categories'
        }
      },
    ],
  },
  {
    path: '/data/products',
    name: 'products',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('products', `views/data/products/Products`),
    },
    meta: {
      title: 'Termékek',
      middleware: [auth, fallback],
      permission: 'data.product.view',
      fallback: 'categories'
    },
    children: [
      {
        path: 'view/:id',
        component: load('products', 'components/data/products/products/View'),
        name: 'ProductViewDialog',
        meta: {
          title: 'Termék megtekintése',
          middleware: [auth, fallback],
          showProductViewDialog: true,
          permission: 'data.product.view',
          fallback: 'products'
        }
      },
      {
        path: 'add',
        component: load('products', 'components/data/products/products/Dialog'),
        name: 'AddProductDialog',
        meta: {
          title: 'Termék hozzáadása',
          middleware: [auth, fallback],
          showAddProductDialog: true,
          permission: 'data.product.create',
          fallback: 'products'
        }
      },
      {
        path: 'update/:id',
        component: load('products', 'components/data/products/products/Dialog'),
        name: 'UpdateProductDialog',
        meta: {
          title: 'Termék módosítása',
          middleware: [auth, fallback],
          showUpdateProductDialog: true,
          permission: 'data.product.update',
          fallback: 'products'
        }
      },
    ],
  },
  {
    path: '/data/products-order',
    name: 'productsOrder',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('products', `views/data/products/Order`),
    },
    meta: {
      title: 'Terméksorrend',
      middleware: [auth, fallback],
      permission: 'data.productorder.view',
      fallback: 'products'
    },
  },
  {
    path: '/data/manufacturers',
    name: 'manufacturers',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('manufacturers', `views/data/products/Manufacturer`),
    },
    meta: {
      title: 'Gyártók',
      middleware: [auth, fallback],
      permission: 'data.manufacturer.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('manufacturers', 'components/data/products/manufacturers/Dialog'),
        name: 'AddManufacturerDialog',
        meta: {
          title: 'Gyártó hozzáadása',
          middleware: [auth, fallback],
          showAddManufacturerDialog: true,
          permission: 'data.manufacturer.create',
          fallback: 'manufacturers'
        }
      },
      {
        path: 'update/:id',
        component: load('manufacturers', 'components/data/products/manufacturers/Dialog'),
        name: 'UpdateManufacturerDialog',
        meta: {
          title: 'Gyártó módosítása',
          middleware: [auth, fallback],
          showUpdateManufacturerDialog: true,
          permission: 'data.manufacturer.update',
          fallback: 'manufacturers'
        }
      },
    ],
  },
  {
    path: '/data/shops/shops',
    name: 'shops',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('categories', `views/data/shops/Shops`),
    },
    meta: {
      title: 'Üzletek',
      middleware: [auth, fallback],
      permission: 'shop.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('shops', 'components/data/shops/shops/Dialog'),
        name: 'AddShopDialog',
        meta: {
          title: 'Üzlet hozzáadása',
          middleware: [auth, fallback],
          showAddShopDialog: true,
          permission: 'shop.create',
          fallback: 'shops'
        }
      },
      {
        path: 'update/:id',
        component: load('shops', 'components/data/shops/shops/Dialog'),
        name: 'UpdateShopDialog',
        meta: {
          title: 'Üzlet módosítása',
          middleware: [auth, fallback],
          showUpdateShopDialog: true,
          permission: 'shop.update',
          fallback: 'shops'
        }
      },
    ]
  },
  {
    path: '/data/shops/categories',
    name: 'shop-categories',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('categories', `views/data/shops/Categories`),
    },
    meta: {
      title: 'Üzlet kategóriák',
      middleware: [auth, fallback],
      permission: 'shopcategory.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('categories', 'components/data/shops/categories/Dialog'),
        name: 'AddShopCategoryDialog',
        meta: {
          title: 'Üzlet kategória hozzáadása',
          middleware: [auth, fallback],
          showAddShopCategoryDialog: true,
          permission: 'shopcategory.create',
          fallback: 'shop-categories'
        }
      },
      {
        path: 'update/:id',
        component: load('categories', 'components/data/shops/categories/Dialog'),
        name: 'UpdateShopCategoryDialog',
        meta: {
          title: 'Üzlet kategória módosítása',
          middleware: [auth, fallback],
          showUpdateShopCategoryDialog: true,
          permission: 'shopcategory.update',
          fallback: 'shop-categories'
        }
      },
    ]
  },
  {
    path: '/data/shops/chains',
    name: 'shop-chains',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('shop-chains', `views/data/shops/Chains`),
    },
    meta: {
      title: 'Üzletláncok',
      middleware: [auth, fallback],
      permission: 'shopchain.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('shop-chains', 'components/data/shops/chains/Dialog'),
        name: 'AddShopChainDialog',
        meta: {
          title: 'Üzletlánc hozzáadása',
          middleware: [auth, fallback],
          showAddShopChainDialog: true,
          permission: 'shopchain.create',
          fallback: 'shop-chains'
        }
      },
      {
        path: 'update/:id',
        component: load('shop-chains', 'components/data/shops/chains/Dialog'),
        name: 'UpdateShopChainDialog',
        meta: {
          title: 'Üzletlánc módosítása',
          middleware: [auth, fallback],
          showUpdateShopChainDialog: true,
          permission: 'shopchain.update',
          fallback: 'shop-chains'
        }
      },
    ]
  },
  {
    path: '/data/partners',
    name: 'partners',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('partners', `views/data/Partners`),
    },
    meta: {
      title: 'Partnerek',
      middleware: [auth, fallback],
      permission: 'partner.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('partners', 'components/data/partners/Dialog'),
        name: 'AddPartnerDialog',
        meta: {
          title: 'Partner hozzáadása',
          middleware: [auth, fallback],
          showAddPartnerDialog: true,
          permission: 'partner.create',
          fallback: 'partners'
        }
      },
      {
        path: 'update/:id',
        component: load('partners', 'components/data/partners/Dialog'),
        name: 'UpdatePartnerDialog',
        meta: {
          title: 'Partner módosítása',
          middleware: [auth, fallback],
          showUpdatePartnerDialog: true,
          permission: 'partner.update',
          fallback: 'partners'
        }
      },
    ],
  },
  {
    path: '/processes/supplier-orders',
    name: 'supplierOrders',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('supplierOrders', `views/processes/SupplierOrders`),
    },
    meta: {
      title: 'Beszállítói megrendelések',
      middleware: [auth, fallback],
      permission: 'supplierorder.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('supplierOrders', 'components/processes/supplierOrders/Dialog'),
        name: 'SupplierOrderViewDialog',
        meta: {
          title: 'Beszállítói megrendelés megtekintése',
          middleware: [auth, fallback],
          showSupplierViewOrderDialog: true,
          permission: 'supplierorder.view',
          fallback: 'supplierOrders'
        }
      },
      {
        path: 'add/:id?',
        component: load('supplierOrders', 'components/processes/supplierOrders/Dialog'),
        name: 'AddSupplierOrderDialog',
        meta: {
          title: 'Beszállítói megrendelés hozzáadása',
          middleware: [auth, fallback],
          showAddSupplierOrderDialog: true,
          permission: 'supplierorder.create',
          fallback: 'supplierOrders'
        }
      },
      {
        path: 'update/:id',
        component: load('supplierOrders', 'components/processes/supplierOrders/Dialog'),
        name: 'UpdateSupplierOrderDialog',
        meta: {
          title: 'Beszállítói megrendelés módosítása',
          middleware: [auth, fallback],
          showUpdateSupplierOrderDialog: true,
          permission: 'supplierorder.update',
          fallback: 'supplierOrders'
        }
      },
    ],
  },
  {
    path: '/processes/supplier-return-orders',
    name: 'supplierReturnOrders',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('supplierReturnOrders', `views/processes/SupplierReturnOrders`),
    },
    meta: {
      title: 'Beszállítói visszáruk',
      middleware: [auth, fallback],
      permission: 'supplierreturnorder.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('supplierReturnOrders', 'components/processes/supplierReturnOrders/Dialog'),
        name: 'SupplierReturnOrderViewDialog',
        meta: {
          title: 'Beszállítói visszáru megtekintése',
          middleware: [auth, fallback],
          showSupplierReturnOrderViewDialog: true,
          permission: 'supplierreturnorder.view',
          fallback: 'supplierReturnOrders'
        }
      },
      {
        path: 'add/:id?',
        component: load('supplierReturnOrders', 'components/processes/supplierReturnOrders/Dialog'),
        name: 'AddSupplierReturnOrderDialog',
        meta: {
          title: 'Beszállítói visszáru hozzáadása',
          middleware: [auth, fallback],
          showAddSupplierReturnOrderDialog: true,
          permission: 'supplierreturnorder.create',
          fallback: 'supplierReturnOrders'
        }
      },
      {
        path: 'update/:id',
        component: load('supplierReturnOrders', 'components/processes/supplierReturnOrders/Dialog'),
        name: 'UpdateSupplierReturnOrderDialog',
        meta: {
          title: 'Beszállítói visszáru módosítása',
          middleware: [auth, fallback],
          showUpdateSupplierReturnOrderDialog: true,
          permission: 'supplierreturnorder.update',
          fallback: 'supplierReturnOrders'
        }
      },
    ],
  },
  {
    path: '/sales/representative-orders',
    name: 'representativeOrders',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('representativeOrders', `views/sales/RepresentativeOrders`),
    },
    meta: {
      title: 'Raktárközi megrendelések',
      middleware: [auth, fallback],
      permission: 'representativeorder.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('representativeOrders', 'components/sales/representativeOrders/Dialog'),
        name: 'RepresentativeOrderViewDialog',
        meta: {
          title: 'Raktárközi megrendelés megtekintése',
          middleware: [auth, fallback],
          showRepresentativeOrderViewDialog: true,
          permission: 'representativeorder.view',
          fallback: 'representativeOrders'
        }
      },
      {
        path: 'add/:id?',
        component: load('representativeOrders', 'components/sales/representativeOrders/Dialog'),
        name: 'AddRepresentativeOrderDialog',
        meta: {
          title: 'Raktárközi megrendelés hozzáadása',
          middleware: [auth, fallback],
          showAddRepresentativeOrderDialog: true,
          permission: 'representativeorder.create',
          fallback: 'representativeOrders'
        }
      },
      {
        path: 'update/:id',
        component: load('representativeOrders', 'components/sales/representativeOrders/Dialog'),
        name: 'UpdateRepresentativeOrderDialog',
        meta: {
          title: 'Raktárközi megrendelés módosítása',
          middleware: [auth, fallback],
          showUpdateRepresentativeOrderDialog: true,
          permission: 'representativeorder.update',
          fallback: 'representativeOrders'
        }
      },
    ],
  },
  {
    path: '/processes/packings',
    name: 'packings',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('packings', `views/processes/Packings`),
    },
    meta: {
      title: 'Csomagolások',
      middleware: [auth, fallback],
      permission: 'packing.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('packings', 'components/processes/packings/View'),
        name: 'PackingViewDialog',
        meta: {
          title: 'Csomagolás megtekintése',
          middleware: [auth, fallback],
          showPackingViewDialog: true,
          permission: 'packing.view',
          fallback: 'packings'
        }
      },
      {
        path: 'add-packing',
        component: load('packings', 'components/processes/packings/Dialog'),
        name: 'AddPackingDialog',
        meta: {
          title: 'Becsomagolás hozzáadása',
          middleware: [auth, fallback],
          showAddPackingDialog: true,
          permission: 'packing.create',
          fallback: 'packings'
        }
      },
      {
        path: 'add-out-packing',
        component: load('packings', 'components/processes/packings/Dialog'),
        name: 'AddOutPackingDialog',
        meta: {
          title: 'Kicsomagolás hozzáadása',
          middleware: [auth, fallback],
          showAddOutPackingDialog: true,
          permission: 'packing.create',
          fallback: 'packings'
        }
      },
    ]
  },
  {
    path: '/processes/declutters',
    name: 'declutters',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('declutters', `views/processes/Declutters/Declutters`),
    },
    meta: {
      title: 'Selejtezések',
      middleware: [auth, fallback],
      permission: 'declutter.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('declutters', 'components/processes/declutters/Dialog'),
        name: 'DeclutterViewDialog',
        meta: {
          title: 'Selejtezés megtekintése',
          middleware: [auth, fallback],
          showDeclutterViewDialog: true,
          permission: 'declutter.view',
          fallback: 'declutters'
        }
      },
      {
        path: 'add',
        component: load('declutters', 'components/processes/declutters/Dialog'),
        name: 'AddDeclutterDialog',
        meta: {
          title: 'Selejtezés hozzáadása',
          middleware: [auth, fallback],
          showAddDeclutterDialog: true,
          permission: 'declutter.create',
          fallback: 'declutters'
        }
      },
      {
        path: 'update/:id',
        component: load('declutters', 'components/processes/declutters/Dialog'),
        name: 'UpdateDeclutterDialog',
        meta: {
          title: 'Selejtezés módosítása',
          middleware: [auth, fallback],
          showUpdateDeclutterDialog: true,
          permission: 'declutter.update',
          fallback: 'declutters'
        }
      },
    ]
  },
  {
    path: '/processes/declutters/reports',
    name: 'declutter-reports',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('declutters', `views/processes/Declutters/DeclutterReports`),
    },
    meta: {
      title: 'Selejtezés jegyzőkönyvek',
      middleware: [auth, fallback],
      permission: 'declutterreport.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('declutters', 'components/processes/declutters/reports/Dialog'),
        name: 'DeclutterReportViewDialog',
        meta: {
          title: 'Selejtezés jegyzőkönyv megtekintése',
          middleware: [auth, fallback],
          showDeclutterReportViewDialog: true,
          permission: 'declutterreport.view',
          fallback: 'declutters'
        }
      },
      {
        path: 'add',
        component: load('declutters', 'components/processes/declutters/reports/Dialog'),
        name: 'AddDeclutterReportDialog',
        meta: {
          title: 'Selejtezés jegyzőkönyv hozzáadása',
          middleware: [auth, fallback],
          showAddDeclutterReportDialog: true,
          permission: 'declutterreport.create',
          fallback: 'declutters'
        }
      },
      {
        path: 'update/:id',
        component: load('declutters', 'components/processes/declutters/reports/Dialog'),
        name: 'UpdateDeclutterReportDialog',
        meta: {
          title: 'Selejtezés jegyzőkönyv módosítása',
          middleware: [auth, fallback],
          showUpdateDeclutterReportDialog: true,
          permission: 'declutterreport.update',
          fallback: 'declutters'
        }
      },
    ]
  },
  {
    path: '/processes/stock-takings/stock-takings',
    name: 'stockTakings',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('stockTakings', `views/processes/stockTakings/StockTakings`),
    },
    meta: {
      title: 'Leltárak',
      middleware: [auth, fallback],
      permission: 'stocktaking.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('stockTakings', 'components/processes/stockTakings/stockTakings/Dialog'),
        name: 'StockTakingViewDialog',
        meta: {
          title: 'Leltár megtekintése',
          middleware: [auth, fallback],
          showStockTakingViewDialog: true,
          permission: 'stocktaking.view',
          fallback: 'stockTakings'
        }
      },
      {
        path: 'add',
        component: load('stockTakings', 'components/processes/stockTakings/stockTakings/Dialog'),
        name: 'AddStockTakingDialog',
        meta: {
          title: 'Leltár hozzáadása',
          middleware: [auth, fallback],
          showAddStockTakingDialog: true,
          permission: 'stocktaking.create',
          fallback: 'stockTakings'
        }
      },
      {
        path: 'update/:id',
        component: load('stockTakings', 'components/processes/stockTakings/stockTakings/Dialog'),
        name: 'UpdateStockTakingDialog',
        meta: {
          title: 'Leltár módosítása',
          middleware: [auth, fallback],
          showUpdateStockTakingDialog: true,
          permission: 'stocktaking.update',
          fallback: 'stockTakings'
        }
      },
    ]
  },
  {
    path: '/processes/stock-takings/stock-taking-reports',
    name: 'stockTakingReports',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('stockTakingReports', `views/processes/stockTakings/StockTakingReports`),
    },
    meta: {
      title: 'Leltár jegyzőkönyvek',
      middleware: [auth, fallback],
      permission: 'stocktakingreport.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('stockTakingReports', 'components/processes/stockTakings/stockTakingReports/Dialog'),
        name: 'StockTakingReportViewDialog',
        meta: {
          title: 'Leltár jegyzőkönyv megtekintése',
          middleware: [auth, fallback],
          showStockTakingReportViewDialog: true,
          permission: 'stocktakingreport.view',
          fallback: 'stockTakingReports'
        }
      },
      {
        path: 'add',
        component: load('stockTakingReports', 'components/processes/stockTakings/stockTakingReports/Dialog'),
        name: 'AddStockTakingReportDialog',
        meta: {
          title: 'Leltár jegyzőkönyv hozzáadása',
          middleware: [auth, fallback],
          showAddStockTakingReportDialog: true,
          permission: 'stocktakingreport.create',
          fallback: 'stockTakingReports'
        }
      },
      {
        path: 'update/:id',
        component: load('stockTakingReports', 'components/processes/stockTakings/stockTakingReports/Dialog'),
        name: 'UpdateStockTakingReportDialog',
        meta: {
          title: 'Leltár jegyzőkönyv módosítása',
          middleware: [auth, fallback],
          showUpdateStockTakingReportDialog: true,
          permission: 'stocktakingreport.update',
          fallback: 'stockTakingReports'
        }
      },
    ]
  },
  {
    path: '/processes/stock-takings/stock-taking-tools',
    name: 'stockTakingTools',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('stockTakingTools', `views/processes/stockTakings/StockTakingTools`),
    },
    meta: {
      title: 'Leltár eszközök',
      middleware: [auth, fallback],
      permission: 'stocktakingtool.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('stockTakingTools', 'components/processes/stockTakings/stockTakingTools/Dialog'),
        name: 'AddStockTakingToolDialog',
        meta: {
          title: 'Leltár eszköz hozzáadása',
          middleware: [auth, fallback],
          showAddStockTakingToolDialog: true,
          permission: 'stocktakingtool.create',
          fallback: 'stockTakingTools'
        }
      },
      {
        path: 'update/:id',
        component: load('stockTakingTools', 'components/processes/stockTakings/stockTakingTools/Dialog'),
        name: 'UpdateStockTakingToolDialog',
        meta: {
          title: 'Leltár eszköz módosítása',
          middleware: [auth, fallback],
          showUpdateStockTakingToolDialog: true,
          permission: 'stocktakingtool.update',
          fallback: 'stockTakingTools'
        }
      },
    ]
  },
  {
    path: '/processes/stock-transformations',
    name: 'stockTransformations',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('stockTransformations', `views/processes/StockTransformations`),
    },
    meta: {
      title: 'Készlet transzformációk',
      middleware: [auth, fallback],
      permission: 'stocktransformation.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('stockTransformations', 'components/processes/stockTransformations/Dialog'),
        name: 'AddDeclutterDialog',
        meta: {
          title: 'Selejtezés hozzáadása',
          middleware: [auth, fallback],
          showAddStockTransformationDialog: true,
          permission: 'stocktransformation.create',
          fallback: 'stockTransformations'
        }
      },
    ]
  },
  {
    path: '/processes/stock-movements',
    name: 'stockMovements',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('stockMovements', `views/processes/StockMovements`),
    },
    meta: {
      title: 'Készletmozgatás',
      middleware: [auth, fallback],
      permission: 'stocktransformation.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('stockMovements', 'components/processes/stockMovements/Dialog'),
        name: 'AddStockMovementDialog',
        meta: {
          title: 'Készletmozgás hozzáadása',
          middleware: [auth, fallback],
          showAddStockMovementDialog: true,
          permission: 'stocktransformation.create',
          fallback: 'stockMovements'
        }
      },
      {
        path: 'view/:id',
        component: load('stockMovements', 'components/processes/stockMovements/Dialog'),
        name: 'ViewStockMovementDialog',
        meta: {
          title: 'Készletmozgás megtekintése',
          middleware: [auth, fallback],
          showViewStockMovementDialog: true,
          permission: 'stocktransformation.create',
          fallback: 'stockMovements'
        }
      },
      {
        path: 'update/:id',
        component: load('stockMovements', 'components/processes/stockMovements/Dialog'),
        name: 'UpdateStockMovementDialog',
        meta: {
          title: 'Készletmozgás módodosítása',
          middleware: [auth, fallback],
          showUpdateStockMovementDialog: true,
          permission: 'stocktransformation.create',
          fallback: 'stockMovements'
        }
      },
    ]
  },
  {
    path: '/representative-processes/representative-drops',
    name: 'representativeDrops',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('representativeDrops', `views/representativeProcesses/RepresentativeDrops`),
    },
    meta: {
      title: 'Termék leadások',
      middleware: [auth, fallback],
      permission: 'representativedrop.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'update/:id',
        component: load('representativeDrops', 'components/representativeProcesses/representativeDrops/Dialog'),
        name: 'UpdateRepresentativeDropDialog',
        meta: {
          title: 'Termek leadás módosítása',
          middleware: [auth, fallback],
          showUpdateRepresentativeDropDialog: true,
          permission: 'representativedrop.update',
          fallback: 'representativeDrops'
        }
      },
    ]
  },
  {
    path: '/representative-processes/representative-transfer-requests',
    name: 'representativeTransferRequests',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('representativeTransferRequests', `views/representativeProcesses/RepresentativeTransferRequests`),
    },
    meta: {
      title: 'Készletáthelyezés kérelmek',
      middleware: [auth, fallback],
      permission: 'representativetransfer.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('representativeTransferRequests', 'components/representativeProcesses/representativeTransferRequests/Dialog'),
        name: 'ViewRepresentativeTransferRequestDialog',
        meta: {
          title: 'Kérelem megtekintése',
          middleware: [auth, fallback],
          showViewRepresentativeTransferRequestDialog: true,
          permission: 'representativetransfer.view',
          fallback: 'representativeTransferRequests'
        }
      },
    ]
  },
  {
    path: '/representative-processes/representative-transfers',
    name: 'representativeTransfers',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('representativeTransfers', `views/representativeProcesses/RepresentativeTransfers`),
    },
    meta: {
      title: 'Készletátadások',
      middleware: [auth, fallback],
      permission: 'representativedrop.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('representativeTransfers', 'components/representativeProcesses/representativeTransfers/Dialog'),
        name: 'ViewRepresentativeTransferDialog',
        meta: {
          title: 'Készletátadás megtekintése',
          middleware: [auth, fallback],
          showViewRepresentativeTransferDialog: true,
          permission: 'representativedrop.view',
          fallback: 'representativeTransfers'
        }
      },
    ]
  },
  {
    path: '/representative-processes/representative-placements',
    name: 'representativePlacements',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('representativePlacements', `views/representativeProcesses/RepresentativePlacements`),
    },
    meta: {
      title: 'Képviselői kihelyezések',
      middleware: [auth, fallback],
      permission: 'representativeplacement.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/representative-processes/representative-sales',
    name: 'representativeSales',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('representativeSales', `views/representativeProcesses/RepresentativeSales`),
    },
    meta: {
      title: 'Képviselői eladások',
      middleware: [auth, fallback],
      permission: 'representativesale.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/representative-processes/representative-prices/default',
    name: 'representativePrices',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('representativePrices', `views/representativeProcesses/RepresentativePrices`),
    },
    meta: {
      title: 'Képviselői árlisták',
      middleware: [auth, fallback],
      permission: 'representativeprice.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/representative-processes/representative-prices/custom',
    name: 'representativePrices',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('representativePrices', `views/representativeProcesses/SpecialPrices`),
    },
    meta: {
      title: 'Képviselői árlisták',
      middleware: [auth, fallback],
      permission: 'representativeprice.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add/:copyFrom?',
        component: load('specialPrices', 'components/representativeProcesses/specialPrices/Dialog'),
        name: 'AddSpecialPriceDialog',
        meta: {
          title: 'Egyedi ár hozzáadása',
          middleware: [auth, fallback],
          showAddSpecialPriceDialog: true,
          permission: 'representativeprice.view',
          fallback: 'representativePrices'
        }
      },
      {
        path: 'update/:id',
        component: load('specialPrices', 'components/representativeProcesses/specialPrices/Dialog'),
        name: 'UpdatePartnerSpecialPriceDialog',
        meta: {
          title: 'Egyedi ár módosítása',
          middleware: [auth, fallback],
          showUpdatePartnerSpecialPriceDialog: true,
          permission: 'representativeprice.view',
          fallback: 'representativePrices'
        }
      },
      {
        path: 'view/:id',
        component: load('specialPrices', 'components/representativeProcesses/specialPrices/Dialog'),
        name: 'ViewPartnerSpecialPriceDialog',
        meta: {
          title: 'Egyedi ár megtekintése',
          middleware: [auth, fallback],
          showViewPartnerSpecialPriceDialog: true,
          permission: 'representativeprice.view',
          fallback: 'representativePrices'
        }
      },
    ]
  },
  {
    path: '/representative-processes/receipt-receives/invoice',
    name: 'invoiceReceiptReceives',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('invoiceReceiptReceives', `views/representativeProcesses/receiptReceives/InvoiceReceiptReceives`),
    },
    meta: {
      title: 'Bizonylat beérkeztetés - számla',
      middleware: [auth, fallback],
      permission: 'receiptreceives.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add/:type',
        component: load('customerOrders', 'components/representativeProcesses/receiptReceives/invoice/Dialog'),
        name: 'AddInvoiceReceiptReceiveDialog',
        meta: {
          title: 'Számla beérkeztetés hozzáadása',
          middleware: [auth, fallback],
          showAddInvoiceReceiptReceiveDialog: true,
          permission: 'receiptreceives.create',
          fallback: 'dashboard'
        }
      },
    ]
  },
  {
    path: '/representative-processes/receipt-receives/delivery',
    name: 'deliveryReceiptReceives',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('deliveryReceiptReceives', `views/representativeProcesses/receiptReceives/DeliveryReceiptReceives`),
    },
    meta: {
      title: 'Bizonylat beérkeztetés - szállítólevél',
      middleware: [auth, fallback],
      permission: 'receiptreceives.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('customerOrders', 'components/representativeProcesses/receiptReceives/delivery/Dialog'),
        name: 'AddDeliveryReceiptReceiveDialog',
        meta: {
          title: 'Szállítólevél beérkeztetés hozzáadása',
          middleware: [auth, fallback],
          showAddDeliveryReceiptReceiveDialog: true,
          permission: 'receiptreceives.create',
          fallback: 'dashboard'
        }
      },
    ]
  },
  {
    path: '/sales/customer-orders',
    name: 'customerOrders',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('customerOrders', `views/sales/CustomerOrders`),
    },
    meta: {
      title: 'Vevői megrendelések',
      middleware: [auth, fallback],
      permission: 'customerorder.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('customerOrders', 'components/sales/customerOrders/Dialog'),
        name: 'CustomerOrderViewDialog',
        meta: {
          title: 'Vevői megrendelés megtekintése',
          middleware: [auth, fallback],
          showCustomerOrderViewDialog: true,
          permission: 'customerorder.view',
          fallback: 'customerOrders'
        }
      },
      {
        path: 'add/:id?',
        component: load('customerOrders', 'components/sales/customerOrders/Dialog'),
        name: 'AddCustomerOrderDialog',
        meta: {
          title: 'Vevői megrendelés hozzáadása',
          middleware: [auth, fallback],
          showAddCustomerOrderDialog: true,
          permission: 'customerorder.create',
          fallback: 'customerOrders'
        }
      },
      {
        path: 'update/:id',
        component: load('customerOrders', 'components/sales/customerOrders/Dialog'),
        name: 'UpdateCustomerOrderDialog',
        meta: {
          title: 'Vevői megrendelés módosítása',
          middleware: [auth, fallback],
          showUpdateCustomerOrderDialog: true,
          permission: 'customerorder.update',
          fallback: 'customerOrders'
        }
      },
    ],
  },
  {
    path: '/sales/proform-customer-orders',
    name: 'proformCustomerOrders',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('proformCustomerOrders', `views/sales/ProformCustomerOrders`),
    },
    meta: {
      title: 'Proform megrendelések',
      middleware: [auth, fallback],
      permission: 'proformcustomerorder.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('proformCustomerOrders', 'components/sales/proformCustomerOrders/Dialog'),
        name: 'ProformCustomerOrderViewDialog',
        meta: {
          title: 'Proform megrendelés megtekintése',
          middleware: [auth, fallback],
          showProformCustomerOrderViewDialog: true,
          permission: 'proformcustomerorder.view',
          fallback: 'proformCustomerOrders'
        }
      },
      {
        path: 'add/:id?',
        component: load('proformCustomerOrders', 'components/sales/proformCustomerOrders/Dialog'),
        name: 'AddProformCustomerOrderDialog',
        meta: {
          title: 'Proform megrendelés hozzáadása',
          middleware: [auth, fallback],
          showAddProformCustomerOrderDialog: true,
          permission: 'proformcustomerorder.create',
          fallback: 'proformCustomerOrders'
        }
      },
      {
        path: 'update/:id',
        component: load('proformCustomerOrders', 'components/sales/proformCustomerOrders/Dialog'),
        name: 'UpdateProformCustomerOrderDialog',
        meta: {
          title: 'Proform megrendelés módosítása',
          middleware: [auth, fallback],
          showUpdateProformCustomerOrderDialog: true,
          permission: 'proformcustomerorder.update',
          fallback: 'proformCustomerOrders'
        }
      },
    ],
  },
  {
    path: '/sales/customer-sales',
    name: 'customerSales',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('customerSales', `views/sales/CustomerSales`),
    },
    meta: {
      title: 'Vevői eladások',
      middleware: [auth, fallback],
      permission: 'customersale.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('customerSales', 'components/sales/customerSales/Dialog'),
        name: 'CustomerSaleViewDialog',
        meta: {
          title: 'Vevői eladás megtekintése',
          middleware: [auth, fallback],
          showCustomerSaleViewDialog: true,
          permission: 'customersale.view',
          fallback: 'customerSales'
        }
      },
      {
        path: 'add/:id?',
        component: load('customerSales', 'components/sales/customerSales/Dialog'),
        name: 'AddCustomerSaleDialog',
        meta: {
          title: 'Vevői eladás hozzáadása',
          middleware: [auth, fallback],
          showAddCustomerSaleDialog: true,
          permission: 'customersale.create',
          fallback: 'customerSales'
        }
      },
      {
        path: 'update/:id',
        component: load('customerSales', 'components/sales/customerSales/Dialog'),
        name: 'UpdateCustomerSaleDialog',
        meta: {
          title: 'Vevői eladás módosítása',
          middleware: [auth, fallback],
          showUpdateCustomerSaleDialog: true,
          permission: 'customersale.update',
          fallback: 'customerSales'
        }
      },
    ],
  },
  {
    path: '/sales/representative-deliveries',
    name: 'representativeDeliveries',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('representativeDeliveries', `views/sales/RepresentativeDeliveries`),
    },
    meta: {
      title: 'Raktárközi szállítólevelek',
      middleware: [auth, fallback],
      permission: 'representativedeliveries.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/sales/invoices',
    name: 'invoices',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('invoices', `views/sales/Invoices`),
    },
    meta: {
      title: 'Számlák',
      middleware: [auth, fallback],
      permission: 'invoice.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('invoices', 'components/sales/uDialog'),
        name: 'InvoiceViewDialog',
        meta: {
          title: 'Számla megtekintése',
          middleware: [auth, fallback],
          showInvoiceViewDialog: true,
          permission: 'invoice.view',
          fallback: 'invoices'
        }
      },
      {
        path: 'payments/:id',
        component: load('invoices', 'components/sales/invoices/PaymentDialog'),
        name: 'InvoicePaymentDialog',
        meta: {
          title: 'Befizetések megtekintése',
          middleware: [auth, fallback],
          showInvoicePaymentDialog: true,
          permission: 'invoice.view',
          fallback: 'invoices'
        }
      },
      {
        path: 'add',
        component: load('invoices', 'components/sales/invoices/Dialog'),
        name: 'AddInvoiceDialog',
        meta: {
          title: 'Számla hozzáadása',
          middleware: [auth, fallback],
          showAddInvoiceDialog: true,
          permission: 'invoice.create',
          fallback: 'invoices'
        }
      },
      {
        path: 'update/:id',
        component: load('invoices', 'components/sales/invoices/Dialog'),
        name: 'UpdateInvoiceDialog',
        meta: {
          title: 'Számla módosítása',
          middleware: [auth, fallback],
          showUpdateInvoiceDialog: true,
          permission: 'invoice.update',
          fallback: 'invoices'
        }
      },
    ],
  },
  {
    path: '/representative-processes/representative-replacements',
    name: 'representativeReplacements',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('representativeReplacements', `views/representativeProcesses/RepresentativeReplacements`),
    },
    meta: {
      title: 'Képviselő áthelyezések',
      middleware: [auth, fallback],
      permission: 'representativereplacement.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('representativeReplacements', 'components/representativeProcesses/representativeReplacements/Dialog'),
        name: 'RepresentativeReplacementViewDialog',
        meta: {
          title: 'Képviselő áthelyezés megtekintése',
          middleware: [auth, fallback],
          showInvoiceViewDialog: true,
          permission: 'representativereplacement.view',
          fallback: 'representativeReplacements'
        }
      },
      {
        path: 'add',
        component: load('representativeReplacements', 'components/representativeProcesses/representativeReplacements/Dialog'),
        name: 'AddRepresentativeReplacementDialog',
        meta: {
          title: 'Képviselő áthelyezés hozzáadása',
          middleware: [auth, fallback],
          showAddRepresentativeReplacementDialog: true,
          permission: 'representativereplacement.create',
          fallback: 'representativeReplacements'
        }
      },
      {
        path: 'update/:id',
        component: load('representativeReplacements', 'components/representativeProcesses/representativeReplacements/Dialog'),
        name: 'UpdateRepresentativeReplacementDialog',
        meta: {
          title: 'Képviselő áthelyezés módosítása',
          middleware: [auth, fallback],
          showUpdateRepresentativeReplacementDialog: true,
          permission: 'representativereplacement.update',
          fallback: 'representativeReplacements'
        }
      },
    ],
  },
  {
    path: '/representative-processes/receipt-transfers',
    name: 'receiptTransfers',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('receiptTransfers', `views/representativeProcesses/ReceiptTransfers`),
    },
    meta: {
      title: 'Bizonylat áthelyezések',
      middleware: [auth, fallback],
      permission: 'receipttransfer.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('receiptTransfers', 'components/representativeProcesses/receiptTransfers/Dialog'),
        name: 'ReceiptTransferViewDialog',
        meta: {
          title: 'Bizonylat áthelyezés megtekintése',
          middleware: [auth, fallback],
          showInvoiceViewDialog: true,
          permission: 'receipttransfer.view',
          fallback: 'receiptTransfers'
        }
      },
      {
        path: 'add',
        component: load('receiptTransfers', 'components/representativeProcesses/receiptTransfers/Dialog'),
        name: 'AddReceiptTransferDialog',
        meta: {
          title: 'Bizonylat áthelyezés hozzáadása',
          middleware: [auth, fallback],
          showAddReceiptTransferDialog: true,
          permission: 'receipttransfer.create',
          fallback: 'receiptTransfers'
        }
      },
      {
        path: 'update/:id',
        component: load('receiptTransfers', 'components/representativeProcesses/receiptTransfers/Dialog'),
        name: 'UpdateReceiptTransferDialog',
        meta: {
          title: 'Bizonylat áthelyezés módosítása',
          middleware: [auth, fallback],
          showUpdateReceiptTransferDialog: true,
          permission: 'receipttransfer.update',
          fallback: 'receiptTransfers'
        }
      },
    ],
  },
  {
    path: '/sales/customer-return-orders',
    name: 'customerReturnOrders',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('customerReturnOrders', `views/sales/CustomerReturnOrders`),
    },
    meta: {
      title: 'Vevői visszáru',
      middleware: [auth, fallback],
      permission: 'customerorder.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('customerReturnOrders', 'components/sales/customerReturnOrders/Dialog'),
        name: 'CustomerReturnOrderViewDialog',
        meta: {
          title: 'Vevői visszáru megtekintése',
          middleware: [auth, fallback],
          showCustomerReturnOrderViewDialog: true,
          permission: 'customerorder.view',
          fallback: 'customerReturnOrders'
        }
      },
      {
        path: 'add/:id?',
        component: load('customerReturnOrders', 'components/sales/customerReturnOrders/Dialog'),
        name: 'AddCustomerReturnOrderDialog',
        meta: {
          title: 'Vevői visszáru hozzáadása',
          middleware: [auth, fallback],
          showAddCustomerReturnOrderDialog: true,
          permission: 'customerorder.create',
          fallback: 'customerReturnOrders'
        }
      },
      {
        path: 'update/:id',
        component: load('customerReturnOrders', 'components/sales/customerReturnOrders/Dialog'),
        name: 'UpdateCustomerReturnOrderDialog',
        meta: {
          title: 'Vevői visszáru módosítása',
          middleware: [auth, fallback],
          showUpdateCustomerReturnOrderDialog: true,
          permission: 'customerorder.update',
          fallback: 'customerReturnOrders'
        }
      },
    ],
  },
  {
    path: '/sales/stowages',
    name: 'stowages',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('stowages', `views/sales/Stowages`),
    },
    meta: {
      title: 'Rakodási listák',
      middleware: [auth, fallback],
      permission: 'stowage.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('stowages', 'components/sales/stowages/Dialog'),
        name: 'StowageViewDialog',
        meta: {
          title: 'Rakodási lista megtekintése',
          middleware: [auth, fallback],
          showStowageViewDialog: true,
          permission: 'stowage.view',
          fallback: 'stowages'
        }
      },
      {
        path: 'add',
        component: load('stowages', 'components/sales/stowages/Dialog'),
        name: 'AddStowageDialog',
        meta: {
          title: 'Rakodási lista hozzáadása',
          middleware: [auth, fallback],
          showAddStowageDialog: true,
          permission: 'stowage.create',
          fallback: 'stowages'
        }
      },
      {
        path: 'update/:id',
        component: load('stowages', 'components/sales/stowages/Dialog'),
        name: 'UpdateStowageDialog',
        meta: {
          title: 'Rakodási lista módosítása',
          middleware: [auth, fallback],
          showUpdateStowageDialog: true,
          permission: 'stowage.update',
          fallback: 'stowages'
        }
      },
    ],
  },
  {
    path: '/processes/inward-handlings',
    name: 'inwardHandlings',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('inwardHandlings', `views/processes/InwardHandlings`),
    },
    meta: {
      title: 'Bevételezések',
      middleware: [auth, fallback],
      permission: 'inwardhandling.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('inwardHandlings', 'components/processes/inwardHandlings/Dialog'),
        name: 'InwardHandlingViewDialog',
        meta: {
          title: 'Bevételezés megtekintése',
          middleware: [auth, fallback],
          showInwardHandlingViewDialog: true,
          permission: 'inwardhandling.view',
          fallback: 'inwardHandlings'
        }
      },
      {
        path: 'add',
        component: load('inwardHandlings', 'components/processes/inwardHandlings/Dialog'),
        name: 'AddInwardHandlingDialog',
        meta: {
          title: 'Bevételezés hozzáadása',
          middleware: [auth, fallback],
          showAddInwardHandlingDialog: true,
          permission: 'inwardhandling.create',
          fallback: 'inwardHandlings'
        }
      },
      {
        path: 'update/:id',
        component: load('inwardHandlings', 'components/processes/inwardHandlings/Dialog'),
        name: 'UpdateInwardHandlingDialog',
        meta: {
          title: 'Bevételezés módosítása',
          middleware: [auth, fallback],
          showUpdateInwardHandlingDialog: true,
          permission: 'inwardhandling.update',
          fallback: 'inwardHandlings'
        }
      },
    ],
  },
  {
    path: '/data/customer-groups',
    name: 'customerGroups',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('customerGroups', `views/data/CustomerGroups`),
    },
    meta: {
      title: 'Vevőcsoportok',
      middleware: [auth, fallback],
      permission: 'customergroup.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('customerGroups', 'components/data/customerGroups/Dialog'),
        name: 'AddCustomerGroupDialog',
        meta: {
          title: 'Vevőcsoport hozzáadása',
          middleware: [auth, fallback],
          showAddCustomerGroupDialog: true,
          permission: 'customergroup.create',
          fallback: 'customerGroups'
        }
      },
      {
        path: 'update/:id',
        component: load('customerGroups', 'components/data/customerGroups/Dialog'),
        name: 'UpdateCustomerGroupDialog',
        meta: {
          title: 'Vevőcsoport módosítása',
          middleware: [auth, fallback],
          showUpdateCustomerGroupDialog: true,
          permission: 'customergroup.update',
          fallback: 'customerGroups'
        }
      },
    ],
  },
  {
    path: '/data/storages',
    name: 'storages',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('storages', `views/data/Storages`),
    },
    meta: {
      title: 'Raktárak',
      middleware: [auth, fallback],
      permission: 'storage.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('storages', 'components/data/storages/View'),
        name: 'ViewStorageDialog',
        meta: {
          title: 'Raktár megtekintése',
          middleware: [auth, fallback],
          showViewStorageDialog: true,
          permission: 'storage.view',
          fallback: 'storages'
        }
      },
      {
        path: 'add',
        component: load('storages', 'components/data/storages/Dialog'),
        name: 'AddStorageDialog',
        meta: {
          title: 'Raktár hozzáadása',
          middleware: [auth, fallback],
          showAddStorageDialog: true,
          permission: 'storage.create',
          fallback: 'storages'
        }
      },
      {
        path: 'update/:id',
        component: load('storages', 'components/data/storages/Dialog'),
        name: 'UpdateStorageDialog',
        meta: {
          title: 'Raktár módosítása',
          middleware: [auth, fallback],
          showUpdateStorageDialog: true,
          permission: 'storage.update',
          fallback: 'storages'
        }
      },
    ],
  },
  {
    path: '/data/services/services',
    name: 'services',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('services', `views/data/services/Services`),
    },
    meta: {
      title: 'Szolgáltatások',
      middleware: [auth, fallback],
      permission: 'data.service.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('services', 'components/data/services/services/Dialog'),
        name: 'AddServiceDialog',
        meta: {
          title: 'Szolgáltatás hozzáadása',
          middleware: [auth, fallback],
          showAddServiceDialog: true,
          permission: 'data.service.create',
          fallback: 'services'
        }
      },
      {
        path: 'update/:id',
        component: load('services', 'components/data/services/services/Dialog'),
        name: 'UpdateServiceDialog',
        meta: {
          title: 'Szolgáltatás módosítása',
          middleware: [auth, fallback],
          showUpdateServiceDialog: true,
          permission: 'data.service.update',
          fallback: 'services'
        }
      },
    ]
  },
  {
    path: '/data/services/categories',
    name: 'service-categories',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('categories', `views/data/services/Categories`),
    },
    meta: {
      title: 'Szolgáltatáskategóriák',
      middleware: [auth, fallback],
      permission: 'data.servicecategory.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('categories', 'components/data/services/categories/Dialog'),
        name: 'AddServiceCategoryDialog',
        meta: {
          title: 'Szolgáltatáskategória hozzáadása',
          middleware: [auth, fallback],
          showAddServiceCategoryDialog: true,
          permission: 'data.servicecategory.create',
          fallback: 'service-categories'
        }
      },
      {
        path: 'update/:id',
        component: load('categories', 'components/data/services/categories/Dialog'),
        name: 'UpdateServiceCategoryDialog',
        meta: {
          title: 'Szolgáltatáskategória módosítása',
          middleware: [auth, fallback],
          showUpdateServiceCategoryDialog: true,
          permission: 'data.servicecategory.update',
          fallback: 'service-categories'
        }
      },
    ]
  },
  {
    path: '/data/own-companies',
    name: 'own-companies',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('services', `views/data/OwnCompanies`),
    },
    meta: {
      title: 'Saját cégek',
      middleware: [auth, fallback],
      permission: 'data.owncompany.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('own-companies', 'components/data/ownCompanies/Dialog'),
        name: 'AddOwnCompanyDialog',
        meta: {
          title: 'Saját cég hozzáadása',
          middleware: [auth, fallback],
          showAddOwnCompanyDialog: true,
          permission: 'data.owncompany.create',
          fallback: 'own-companies'
        }
      },
      {
        path: 'update/:id',
        component: load('own-companies', 'components/data/ownCompanies/Dialog'),
        name: 'UpdateOwnCompanyDialog',
        meta: {
          title: 'Saját cég módosítása',
          middleware: [auth, fallback],
          showUpdateOwnCompanyDialog: true,
          permission: 'data.owncompany.update',
          fallback: 'own-companies'
        }
      },
    ]
  },
  {
    path: '/todos',
    name: 'todos',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('todos', `views/todos/Todos`),
    },
    meta: {
      title: 'Todo kezelő',
      middleware: [auth, fallback],
      permission: 'todo.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('todos', 'components/todos/View'),
        name: 'ViewTodoDialog',
        meta: {
          title: 'Todo megtekintése',
          middleware: [auth, fallback],
          showViewTodoDialog: true,
          permission: 'todo.view',
          fallback: 'todos'
        }
      },
      {
        path: 'add',
        component: load('todos', 'components/todos/Dialog'),
        name: 'AddTodoDialog',
        meta: {
          title: 'Todo hozzáadása',
          middleware: [auth, fallback],
          showAddTodoDialog: true,
          permission: 'todo.create',
          fallback: 'todos'
        }
      },
      {
        path: 'update/:id',
        component: load('todos', 'components/todos/Dialog'),
        name: 'UpdateTodoDialog',
        meta: {
          title: 'Todo módosítása',
          middleware: [auth, fallback],
          showUpdateTodoDialog: true,
          permission: 'todo.update',
          fallback: 'todos'
        }
      },
    ],
  },
  {
    path: '/todo-recurring-patterns',
    name: 'todo-recurring-patterns',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('todos', `views/todos/TodoRecurringPatterns`),
    },
    meta: {
      title: 'Ciklikus todo szabályok',
      middleware: [auth, fallback],
      permission: 'todo.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('todos', 'components/todos/recurringPatterns/Dialog'),
        name: 'AddTodoRecurringPatternDialog',
        meta: {
          title: 'Todo szabály hozzáadása',
          middleware: [auth, fallback],
          showAddTodoRecurringPatternDialog: true,
          permission: 'todo.create',
          fallback: 'todo-recurring-patterns'
        }
      },
      {
        path: 'update/:id',
        component: load('todos', 'components/todos/recurringPatterns/Dialog'),
        name: 'UpdateTodoRecurringPatternDialog',
        meta: {
          title: 'Todo szabály módosítása',
          middleware: [auth, fallback],
          showUpdateTodoRecurringPatternDialog: true,
          permission: 'todo.update',
          fallback: 'todo-recurring-patterns'
        }
      },
    ],
  },
  {
    path: '/representative-processes/tasks',
    name: 'tasks',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('tasks', `views/representativeProcesses/Tasks`),
    },
    meta: {
      title: 'Időszaki munkák',
      middleware: [auth, fallback],
      permission: 'process.task.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('tasks', 'components/representativeProcesses/tasks/View'),
        name: 'TaskViewDialog',
        meta: {
          title: 'Időszaki munka megtekintése',
          middleware: [auth, fallback],
          showTaskViewDialog: true,
          permission: 'process.task.view',
          fallback: 'tasks'
        }
      },
      {
        path: 'add',
        component: load('tasks', 'components/representativeProcesses/tasks/Dialog'),
        name: 'AddTaskDialog',
        meta: {
          title: 'Időszaki munka hozzáadása',
          middleware: [auth, fallback],
          showAddTaskDialog: true,
          permission: 'process.task.create',
          fallback: 'tasks'
        }
      },
      {
        path: 'update/:id',
        component: load('tasks', 'components/representativeProcesses/tasks/Dialog'),
        name: 'UpdateTaskDialog',
        meta: {
          title: 'Időszaki munka módosítása',
          middleware: [auth, fallback],
          showUpdateTaskDialog: true,
          permission: 'process.task.update',
          fallback: 'tasks'
        }
      },
    ],
  },
  {
    path: '/representative-processes/tour-calendars',
    name: 'tourCalendars',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('tasks', `views/representativeProcesses/TourCalendars`),
    },
    meta: {
      title: 'Túranaptár',
      middleware: [auth, fallback],
      permission: 'tourcalendar.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('tasks', 'components/representativeProcesses/tourCalendars/Dialog'),
        name: 'AddTourCalendarDialog',
        meta: {
          title: 'Túranaptár hozzáadása',
          middleware: [auth, fallback],
          showAddTourCalendarDialog: true,
          permission: 'tourcalendar.create',
          fallback: 'tourCalendars'
        }
      },
      {
        path: 'update/:id',
        component: load('tasks', 'components/representativeProcesses/tourCalendars/Dialog'),
        name: 'UpdateTourCalendarDialog',
        meta: {
          title: 'Túranaptár módosítása',
          middleware: [auth, fallback],
          showUpdateTourCalendarDialog: true,
          permission: 'tourcalendar.update',
          fallback: 'tasks'
        }
      },
    ],
  },
  {
    path: '/representative-processes/tour-calendar-rules',
    name: 'tourCalendarRules',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('tasks', `views/representativeProcesses/TourCalendarRules`),
    },
    meta: {
      title: 'Túranaptár szabályok',
      middleware: [auth, fallback],
      permission: 'tourcalendarrules.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('tasks', 'components/representativeProcesses/tourCalendarRules/Dialog'),
        name: 'AddTourCalendarRuleDialog',
        meta: {
          title: 'Túranaptár szabály hozzáadása',
          middleware: [auth, fallback],
          showAddTourCalendarRuleDialog: true,
          permission: 'tourcalendarrules.create',
          fallback: 'tourCalendars'
        }
      },
      {
        path: 'update/:id',
        component: load('tasks', 'components/representativeProcesses/tourCalendarRules/Dialog'),
        name: 'UpdateTourCalendarRuleDialog',
        meta: {
          title: 'Túranaptár szabály módosítása',
          middleware: [auth, fallback],
          showUpdateTourCalendarRuleDialog: true,
          permission: 'tourcalendarrules.update',
          fallback: 'tasks'
        }
      },
    ],
  },
  {
    path: '/representative-processes/payments',
    name: 'representativePayments',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('tasks', `views/representativeProcesses/RepresentativePayments`),
    },
    meta: {
      title: 'Képviselői befizetések',
      middleware: [auth, fallback],
      permission: 'representativepayment.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('tasks', 'components/representativeProcesses/representativePayments/Dialog'),
        name: 'AddRepresentativePaymentDialog',
        meta: {
          title: 'Befizetés hozzáadása',
          middleware: [auth, fallback],
          showAddRepresentativePaymentDialog: true,
          permission: 'representativepayment.create',
          fallback: 'representativePayments'
        }
      },
      {
        path: 'update/:id',
        component: load('tasks', 'components/representativeProcesses/representativePayments/Dialog'),
        name: 'UpdateRepresentativePaymentDialog',
        meta: {
          title: 'Befizetés módosítása',
          middleware: [auth, fallback],
          showUpdateRepresentativePaymentDialog: true,
          permission: 'representativepayment.update',
          fallback: 'representativePayments'
        }
      },
    ],
  },
  {
    path: '/representative-processes/representative-forms',
    name: 'representativeForms',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('representative-forms', `views/representativeProcesses/RepresentativeForms`),
    },
    meta: {
      title: 'Nyomtatványok',
      middleware: [auth, fallback],
      permission: 'representativeform.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('representative-forms', 'components/representativeProcesses/representativeForms/Dialog'),
        name: 'AddRepresentativeFormDialog',
        meta: {
          title: 'Nyomtatvány hozzáadása',
          middleware: [auth, fallback],
          showAddRepresentativeFormDialog: true,
          permission: 'representativeform.create',
          fallback: 'representativeForms'
        }
      },
      {
        path: 'update/:id',
        component: load('representative-forms', 'components/representativeProcesses/representativeForms/Dialog'),
        name: 'UpdateRepresentativeFormDialog',
        meta: {
          title: 'Nyomtatvány módosítása',
          middleware: [auth, fallback],
          showUpdateRepresentativeFormDialog: true,
          permission: 'representativeform.update',
          fallback: 'representativeForms'
        }
      },
    ],
  },
  {
    path: '/sales/invoice-books',
    name: 'invoice-books',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('invoice-books', `views/sales/InvoiceBooks`),
    },
    meta: {
      title: 'Számlatömbök',
      middleware: [auth, fallback],
      permission: 'invoicebook.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('invoice-books', 'components/sales/invoiceBooks/View'),
        name: 'ViewInvoiceBookDialog',
        meta: {
          title: 'Számlatömb megtekintése',
          middleware: [auth, fallback],
          showViewInvoiceBookDialog: true,
          permission: 'invoicebook.view',
          fallback: 'invoice-books'
        }
      },
      {
        path: 'add',
        component: load('invoice-books', 'components/sales/invoiceBooks/Dialog'),
        name: 'AddInvoiceBookDialog',
        meta: {
          title: 'Számlatömb hozzáadása',
          middleware: [auth, fallback],
          showAddInvoiceBookDialog: true,
          permission: 'invoicebook.create',
          fallback: 'invoice-books'
        }
      },
      {
        path: 'update/:id',
        component: load('invoice-books', 'components/sales/invoiceBooks/Dialog'),
        name: 'UpdateInvoiceBookDialog',
        meta: {
          title: 'Számlatömb módosítása',
          middleware: [auth, fallback],
          showUpdateInvoiceBookDialog: true,
          permission: 'invoicebook.update',
          fallback: 'invoice-books'
        }
      },
    ],
  },
  {
    path: '/app-versions',
    name: 'app-versions',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('app-versions', `views/AppVersions`),
    },
    meta: {
      title: 'App verziók',
      middleware: [auth, fallback],
      permission: 'appversion.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('app-versions', 'components/appVersions/Dialog'),
        name: 'AddAppVersionDialog',
        meta: {
          title: 'App verzió hozzáadása',
          middleware: [auth, fallback],
          showAddAppVersionDialog: true,
          permission: 'appversion.create',
          fallback: 'app-versions'
        }
      },
    ],
  },
  {
    path: '/doc-versions',
    name: 'doc-versions',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('doc-versions', `views/DocVersions`),
    },
    meta: {
      title: 'Dokumentáció verziók',
      middleware: [auth, fallback],
      permission: 'docversion.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('doc-versions', 'components/docVersions/Dialog'),
        name: 'AddDocVersionDialog',
        meta: {
          title: 'Dokumentáció verzió hozzáadása',
          middleware: [auth, fallback],
          showAddDocVersionDialog: true,
          permission: 'docversion.create',
          fallback: 'doc-versions'
        }
      },
    ],
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: load('forgotPassword', `pages/ForgotPassword`),
    meta: {
      auth: false
    }
  },
  {
    path: '/reset-password/:token',
    name: 'reset-password-form',
    component: load('resetPassword', `pages/ResetPasswordForm`),
    meta: {
      auth: false
    }
  },
  {
    path: '/receipts',
    name: 'receiptSettings',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('cars', `views/Receipts`),
    },
    meta: {
      title: 'Bizonylat beállítások',
      middleware: [auth, fallback],
      permission: 'receiptsetting.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/ntax-invoices',
    name: 'ntax-invoices',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('ntax', `views/ntax/Invoices`),
    },
    meta: {
      title: 'NTAX számla export',
      middleware: [auth, fallback],
      permission: 'ntax.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/ntax-partners',
    name: 'ntax-partners',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('ntax', `views/ntax/Partners`),
    },
    meta: {
      title: 'NTAX partnerek',
      middleware: [auth, fallback],
      permission: 'ntax.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'update/:id',
        component: load('ntax', 'components/ntax/partners/Dialog'),
        name: 'UpdateNtaxPartnerDialog',
        meta: {
          title: 'NTAX partner módosítása',
          middleware: [auth, fallback],
          showUpdateNtaxPartnerDialog: true,
          permission: 'ntax.update',
          fallback: 'ntax-partners'
        }
      },
    ],
  },
  {
    path: '/docket/document-types',
    name: 'document-types',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('documentTypes', `views/docket/DocumentTypes`),
    },
    meta: {
      title: 'Irattípusok',
      middleware: [auth, fallback],
      permission: 'documenttype.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('documentTypes', 'components/docket/documentTypes/Dialog'),
        name: 'AddDocumentTypeDialog',
        meta: {
          title: 'Irattípus hozzáadása',
          middleware: [auth, fallback],
          showAddDocumentTypeDialog: true,
          permission: 'documenttype.create',
          fallback: 'document-types'
        }
      },
      {
        path: 'update/:id',
        component: load('documentTypes', 'components/docket/documentTypes/Dialog'),
        name: 'UpdateDocumentTypeDialog',
        meta: {
          title: 'Irattípus módosítása',
          middleware: [auth, fallback],
          showUpdateDocumentTypeDialog: true,
          permission: 'documenttype.update',
          fallback: 'document-types'
        }
      },
    ]
  },
  {
    path: '/docket/docket-books',
    name: 'docket-books',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('docketBooks', `views/docket/DocketBooks`),
    },
    meta: {
      title: 'Iktatókönyvek',
      middleware: [auth, fallback],
      permission: 'docketbook.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'add',
        component: load('docketBooks', 'components/docket/docketBooks/Dialog'),
        name: 'AddDocketBookDialog',
        meta: {
          title: 'Iktatókönyv hozzáadása',
          middleware: [auth, fallback],
          showAddDocketBookDialog: true,
          permission: 'docketbook.create',
          fallback: 'docket-books'
        }
      },
      {
        path: 'update/:id',
        component: load('documentTypes', 'components/docket/docketBooks/Dialog'),
        name: 'UpdateDocketBookDialog',
        meta: {
          title: 'Iktatókönyv módosítása',
          middleware: [auth, fallback],
          showUpdateDocketBookDialog: true,
          permission: 'docketbook.update',
          fallback: 'docket-books'
        }
      },
    ]
  },
  {
    path: '/docket/dockets',
    name: 'dockets',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('docketBooks', `views/docket/Dockets`),
    },
    meta: {
      title: 'Iktatások',
      middleware: [auth, fallback],
      permission: 'docket.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/:id',
        component: load('dockets', 'components/docket/dockets/View'),
        name: 'DocketViewDialog',
        meta: {
          title: 'Iktatás megtekintése',
          middleware: [auth, fallback],
          showDocketViewDialog: true,
          permission: 'docket.view',
          fallback: 'dockets'
        }
      },
      {
        path: 'add',
        component: load('dockets', 'components/docket/dockets/Dialog'),
        name: 'AddDocketDialog',
        meta: {
          title: 'Iktatás hozzáadása',
          middleware: [auth, fallback],
          showAddDocketDialog: true,
          permission: 'docket.create',
          fallback: 'dockets'
        }
      },
      {
        path: 'update/:id',
        component: load('documentTypes', 'components/docket/dockets/Dialog'),
        name: 'UpdateDocketDialog',
        meta: {
          title: 'Iktatás módosítása',
          middleware: [auth, fallback],
          showUpdateDocketDialog: true,
          permission: 'docket.update',
          fallback: 'docket'
        }
      },
    ]
  },
  {
    path: '/reports/outstandings',
    name: 'outstandings',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('outstandings', `views/reports/Outstandings`),
    },
    meta: {
      title: 'Kintlévőségek',
      middleware: [auth, fallback],
      permission: 'outstandingreport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/representative-task',
    name: 'representative-task',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('representativeTasks', `views/reports/RepresentativeTask`),
    },
    meta: {
      title: 'Időszaki munka kimutatás',
      middleware: [auth, fallback],
      permission: 'representativetaskreport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/pareto',
    name: 'pareto',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('pareto', `views/reports/Pareto`),
    },
    meta: {
      title: 'Pareto',
      middleware: [auth, fallback],
      permission: 'paretoreport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/product-history',
    name: 'productHistory',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('productHistory', `views/reports/ProductHistory`),
    },
    meta: {
      title: 'Terméktörténet',
      middleware: [auth, fallback],
      permission: 'producthistory.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/stock-difference',
    name: 'stockDifference',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('stockDifference', `views/reports/StockDifference`),
    },
    meta: {
      title: 'Leltáreltérés',
      middleware: [auth, fallback],
      permission: 'stockdifference.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/stock-value',
    name: 'stockValue',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('stockValue', `views/reports/StockValue`),
    },
    meta: {
      title: 'Készletérték',
      middleware: [auth, fallback],
      permission: 'stockvalue.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/simple-stock-value',
    name: 'stockValue',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('simpleStockValue', `views/reports/SimpleStockValue`),
    },
    meta: {
      title: 'Készletérték',
      middleware: [auth, fallback],
      permission: 'simplestockvalue.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/product-consumption',
    name: 'productConsumption',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('stockValue', `views/reports/ProductConsumption`),
    },
    meta: {
      title: 'Termékfogyás',
      middleware: [auth, fallback],
      permission: 'productconsumption.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/representative-payments/sum',
    name: 'representativePaymentsReportSum',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('representativePaymentsReport', `views/reports/representativePayments/SumPayments`),
    },
    meta: {
      title: 'Összesített befizetések',
      middleware: [auth, fallback],
      permission: 'representativepaymentreport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/representative-payments/detailed',
    name: 'representativePaymentsReportDetailed',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('representativePaymentsReport', `views/reports/representativePayments/DetailedPayments`),
    },
    meta: {
      title: 'Részletes befizetések',
      middleware: [auth, fallback],
      permission: 'representativepaymentreport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/representative-payments/rolling',
    name: 'representativePaymentsReport',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('representativePaymentsReport', `views/reports/representativePayments/RollingPayments`),
    },
    meta: {
      title: 'Görgetett befizetések',
      middleware: [auth, fallback],
      permission: 'representativepaymentreport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/price-breakdown',
    name: 'priceBreakdownReport',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('priceBreakdownReport', `views/reports/PriceBreakdown`),
    },
    meta: {
      title: 'Árbontás',
      middleware: [auth, fallback],
      permission: 'pricebreakdown.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/storage-stock',
    name: 'storageStockReport',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('storageStockReport', `views/reports/StorageStock`),
    },
    meta: {
      title: 'Árukészlet',
      middleware: [auth, fallback],
      permission: 'storagestockreport.view',
      fallback: 'dashboard'
    },
    children: [
      {
        path: 'view/products/:productId/storages/:storageId',
        component: load('storage-stock', 'components/reports/storageStock/View'),
        name: 'ViewStorageStockDialog',
        meta: {
          title: 'Árukészlet - részletes megtekintése',
          middleware: [auth, fallback],
          showViewStorageStockDialog: true,
          permission: 'storagestockreport.view',
          fallback: 'storages'
        }
      },
    ]
  },
  {
    path: '/reports/pallet',
    name: 'pallet',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('vat', `views/reports/Pallet`),
    },
    meta: {
      title: 'Raklap kimutatás',
      middleware: [auth, fallback],
      permission: 'palletreport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/vat/central',
    name: 'vatCentral',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('vat', `views/reports/vat/Central`),
    },
    meta: {
      title: 'Áfa kimutatás - központi',
      middleware: [auth, fallback],
      permission: 'vatreport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/vat/representative',
    name: 'vatRepresentative',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('vat', `views/reports/vat/Representative`),
    },
    meta: {
      title: 'Áfa kimutatás - képviselői',
      middleware: [auth, fallback],
      permission: 'vatreport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/vat/representative/summary',
    name: 'vatRepresentativeSummary',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('vat', `views/reports/vat/RepresentativeSummary`),
    },
    meta: {
      title: 'Áfa kimutatás - képviselői összegzés',
      middleware: [auth, fallback],
      permission: 'vatreport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/vat/representative/detailed',
    name: 'vatRepresentativeDetailed',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('vat', `views/reports/vat/RepresentativeDetailed`),
    },
    meta: {
      title: 'Áfa kimutatás - képviselői részletes',
      middleware: [auth, fallback],
      permission: 'vatreport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/neta/central',
    name: 'netaCentral',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('neta', `views/reports/neta/Central`),
    },
    meta: {
      title: 'Neta kimutatás - központi',
      middleware: [auth, fallback],
      permission: 'netareport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/neta/representative',
    name: 'netaRepresentative',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('neta', `views/reports/neta/Representative`),
    },
    meta: {
      title: 'Neta kimutatás - képviselői',
      middleware: [auth, fallback],
      permission: 'netareport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/worktime',
    name: 'worktime',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('worktime', `views/reports/Worktime`),
    },
    meta: {
      title: 'Munkaidő kimutatás',
      middleware: [auth, fallback],
      permission: 'worktimereport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/nav-audit',
    name: 'navAudit',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('navaudit', `views/reports/NavAudit`),
    },
    meta: {
      title: 'Adóhatósági ellenőrzési adatszolgáltatás',
      middleware: [auth, fallback],
      permission: 'navaudit.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/commission',
    name: 'commission',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('commission', `views/reports/Commission`),
    },
    meta: {
      title: 'Jutalék kimutatás',
      middleware: [auth, fallback],
      permission: 'commissionreport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/representatives',
    name: 'representatives',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('commission', `views/reports/Turnover`),
    },
    meta: {
      title: 'Területi vezetői kimutatás',
      middleware: [auth, fallback],
      permission: 'representativereport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/piros-mogyoros',
    name: 'piros-mogyoros',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('commission', `views/reports/PirosMogyoros`),
    },
    meta: {
      title: 'Piros Mogyorós kimutatás',
      middleware: [auth, fallback],
      permission: 'pirosmogyorosreport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/invoice-items',
    name: 'invoiceitems',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('invoiceitems', `views/reports/InvoiceItems`),
    },
    meta: {
      title: 'Vevői számla tételek',
      middleware: [auth, fallback],
      permission: 'invoiceitemsreport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/inward-handling-items',
    name: 'inwardhandlingitems',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('inwardhandlingitems', `views/reports/InwardHandlingItems`),
    },
    meta: {
      title: 'Beszállítás napokra',
      middleware: [auth, fallback],
      permission: 'inwardhandlingitemsreport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/customer-sale-and-return',
    name: 'customersaleandreturn',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('customersaleandreturn', `views/reports/CustomerSaleAndReturn`),
    },
    meta: {
      title: 'Vevői eladások és viszáru',
      middleware: [auth, fallback],
      permission: 'customersaleandreturnreport.view',
      fallback: 'dashboard'
    },
  },
  {
    path: '/reports/invoice-items-by-partner',
    name: 'invoiceitemsbypartner',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('invoiceitemsbypartner', `views/reports/InvoiceItemsByPartner`),
    },
    meta: {
      title: 'Vevői tételes lista',
      middleware: [auth, fallback],
      permission: 'invoiceitemsbypartnerreport.view',
      fallback: 'dashboard'
    },
  },


  {
    path: '/imports',
    name: 'imports',
    components: {
      menu: load('navigation', `components/Menu`),
      default: load('imports', `views/imports/Imports`),
    },
    meta: {
      title: 'Importok',
      middleware: [auth, fallback],
      //new role
      permission: 'stowage.view',
      fallback: 'dashboard'
    },
  },




  {
    path: '*',
    redirect:
      '/'
  },
];
